module.exports = __webpack_public_path__ + "media/overlays/07-f8da0281.png";